// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
// 引入 store
import store from "./store/index";
import request from "@/api/index.js";
import useChain from "./utils/$c.js";
import "./assets/css/base.less";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
// 导入字体CSS文件
import './assets/font/fonts.css';
import VueClipboard from 'v-clipboard'
import Vue2OrgTree from 'vue-tree-color'
// import VueDraggableResizable from 'vue-draggable-resizable'
// import 'vue-draggable-resizable/dist/VueDraggableResizable.css'
import VueLazyload from "vue-lazy-load"
import infiniteScroll from 'vue-infinite-scroll';
import '@icon-park/vue/styles/index.css';

// 引入Vue Tour新手引导插件
import VueTour from 'vue-tour'
// import "vue-tour/dist/vue-tour.css";
require('vue-tour/dist/vue-tour.css')
// 引入自定义新手引导样式
// import "./assets/css/tourguide.css";

// 引入FFmpeg CDN加载脚本
import '../static/ffmpeg-cdn.js';

import 'highlight.js/styles/monokai-sublime.min.css';
 
// Vue.component('vue-draggable-resizable', VueDraggableResizable)

Vue.prototype.$request = request; // 接口文件
Vue.prototype.$c = useChain;
Vue.config.productionTip = false;
Vue.use(Vue2OrgTree)
Vue.use(VueClipboard)
Vue.use(ElementUI)
Vue.use(VueLazyload)
Vue.use(infiniteScroll);
// 使用VueTour插件
Vue.use(VueTour)

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js